export default "__VITE_ASSET__Cb_atSxU__"